// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f8679517","732":"a6f85101","977":"ae6eac4a"}[chunkId] + ".chunk.js";
};